import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/lib/site";

export const Services = () => (
  <section id="services" className="relative py-24 md:py-32 bg-[#0b2a5b] grain overflow-hidden" data-testid="services-section">
    <div className="absolute top-0 right-0 h-80 w-80 bg-primary/30 blur-[120px] rounded-full" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <p className="overline text-[#8fb4f5] mb-4">What We Do</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-white leading-tight">
            Advisory across the full arc of your financial life.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-lg text-slate-300 leading-relaxed">
            Integrated services delivered by a single, dedicated team — so your strategy stays
            coherent from first plan to legacy.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Circle;
          return (
            <Reveal key={s.key} delay={i * 0.07}>
              <div
                data-testid={`service-card-${s.key}`}
                className="group h-full rounded-2xl border border-white/10 bg-white/[0.04] p-7 hover:bg-white/[0.08] hover:border-white/25 transition-[background-color,border-color] duration-300"
              >
                <div className="h-12 w-12 rounded-xl bg-white/10 flex items-center justify-center text-[#8fb4f5] group-hover:text-white transition-colors duration-300">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-white">{s.title}</h3>
                <p className="mt-3 text-slate-300 leading-relaxed text-[0.95rem]">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
